import "../sass/Video.scss";
// import { FormattedMessage } from 'react-intl';

export default function Video({index,gererClicProjet,toolTip,videoUrl,title}) {

    return (
        <div > {/* Mettre classname Video ici */}
            <h4>{title}</h4>
                <video onClick={gererClicProjet} alt={index} className="Video" width="500" autoPlay loop muted title={toolTip}>
                    <source src={videoUrl} />
                </video>
        </div>
    );

}